<div class="relative">
  <mat-card class="p-4">
    @if (selectedOrderLoading()) {
      <div class="absolute inset-0 flex items-center justify-center bg-white/80 z-50">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    } @else if (selectedOrderError()) {
      <div class="flex justify-center p-4">
        <p class="text-red-500">{{ errorText }}</p>
      </div>
    } @else if (order && order !== null) {
      <div class="p-6 flex justify-between">
        <div class="flex flex-col gap-2">
          <div class="text-xl font-bold">
            Job #: <span class="font-normal">{{ order?.orderId }}</span>
          </div>
          <div>
            <span class="text-gray-400">Created By: </span>
            <span class="font-medium"
              >{{ order?.createdBy?.firstName }} {{ order?.createdBy?.lastName }}</span
            >
          </div>
          <div>
            <span class="text-gray-400">Created On: </span>
            <span class="font-medium">{{ order?.dateCreated | date: 'medium' }}</span>
          </div>
          <div>
            Quote ID:
            <a
              [routerLink]="['/quotes', order?.quote.id, 'view']"
              class="text-blue-600 underline"
              >{{ order?.quote.quoteId }}</a
            >
          </div>
        </div>

        <div class="flex flex-col gap-4 min-w-80">
          <div>
            <h4 class="font-medium mb-1 text-gray-400">Assignee:</h4>
            <p class="pl-4">{{ order?.assignee?.firstName }} {{ order?.assignee?.lastName }}</p>
          </div>

          <div>
            <h4 class="font-medium mb-1 text-gray-400">Status:</h4>
            <p class="pl-4">{{ order?.status }}</p>
          </div>

          <div>
            <h4 class="font-medium mb-1 text-gray-400">Feet Per Reel:</h4>
            <p class="pl-4">{{ order?.feetPerReel }}</p>
          </div>

          <div>
            <h4 class="font-medium mb-1 text-gray-400">Client:</h4>
            <div class="space-y-1">
              <p class="pl-4">#{{ order?.client?.code }}</p>
              <p class="pl-4">{{ order?.client?.company }}</p>
              <p class="pl-4">{{ order?.client?.firstName }} {{ order?.client?.lastName }}</p>
              <p class="pl-4">{{ order?.client?.email }}</p>
              <p class="pl-4">{{ order?.client?.phone }}</p>
            </div>
          </div>
        </div>

        <div class="w-64">
          <div class="bg-white rounded shadow-md p-4">
            <h3 class="text-gray-600 font-normal mb-4 pb-2">Options</h3>

            <a
              class="py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              [routerLink]="['/orders', route.snapshot.paramMap.get('id'), 'edit']"
            >
              <span>Edit Details</span>
              <mat-icon>edit</mat-icon>
            </a>

            <button
              class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              (click)="deleteOrder(order)"
            >
              <span>Delete</span>
              <mat-icon>delete</mat-icon>
            </button>

            <button
              class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              (click)="changeArchiveStatus(order)"
            >
              <span>{{ order?.archived ? 'Unarchive' : 'Archive' }}</span>
              <mat-icon>archive</mat-icon>
            </button>

            <button
              class="w-full font-normal py-3 flex justify-between items-center cursor-pointer hover:text-blue-500"
              (click)="exportOrder(order)"
            >
              <span>Export</span>
              <mat-icon>print</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <form [formGroup]="form" class="py-6 flex flex-col gap-6">
        <mat-card class="mb-4">
          <ciwc-order-manage-general
            [form]="generalForm"
            [orderDetails]="order"
            [viewDisable]="true"
            [isSaving]="selectedOrderLoading()"
          >
          </ciwc-order-manage-general>
          <div class="mt-4">
            <ciwc-order-job-details
              [form]="jobDetailsForm"
              [viewDisabled]="true"
              [orderDetails]="order"
            ></ciwc-order-job-details>
          </div>

          <div class="mt-4">
            <ciwc-production-flow
              [parentForm]="form"
              [orderDetails]="order"
              [details]="order?.details?.[0] ?? {}"
              [viewDisable]="true"
              [createShipmentGroup]="boundCreateShipmentGroup"
              [itemProcesses]="order?.itemProcesses ?? []"
              [readonlySpecFields]="false"
            >
            </ciwc-production-flow>
          </div>

          <div class="mt-4">
            <ciwc-order-item-processes
              [parentForm]="form"
              [orderDetails]="order"
              [itemProcesses]="order?.itemProcesses ?? []"
              [viewDisable]="true"
            >
            </ciwc-order-item-processes>
          </div>

          <div class="mt-4">
            <ciwc-order-job-follow-up
              [followUps]="followUps"
              [viewDisable]="true"
              [orderDetails]="order"
            >
            </ciwc-order-job-follow-up>
          </div>

          <div class="mt-4">
            <div class="flex flex-col md:flex-row gap-8">
              <div class="w-full md:w-1/2">
                <ciwc-order-note-history
                  [orderDetails]="order"
                  [viewDisable]="true"
                ></ciwc-order-note-history>
              </div>
              <div class="w-full md:w-1/2">
                <ciwc-order-change-history [orderDetails]="order"></ciwc-order-change-history>
              </div>
            </div>
          </div>
        </mat-card>
      </form>
    }
  </mat-card>
</div>
